import classNames from "classnames";
import React from "react";
import { openExternalUrl } from "../external_link";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppButton } from "./Generic/AppButton";
import AppSlideFadeIn from "./Generic/AppSlideFadeIn";
import MedFlytPassportLogo from "./MedFlytPassportLogo";
import ScaffoldTitle from "./Scaffold/components/ScaffoldTitle";
import Scaffold from "./Scaffold/Scaffold";

interface MedFlytPassportTermsApprovementProps {
  onCancelClick: () => void;
  onApproveClick: () => void;
}

const MedFlytPassportTermsApprovement = (props: MedFlytPassportTermsApprovementProps) => {
  const { onCancelClick, onApproveClick } = props;

  const [isTermsApproved, setTermsApproved] = React.useState(false);
  const [isBadTermsClickAttempt, setBadTermsClickAttempt] = React.useState(false);
  const [isTermsShake, setIsTermsShake] = React.useState(false);

  const handleClickSetTermsApproved = React.useCallback(() => {
    setTermsApproved(!isTermsApproved);
    if (isBadTermsClickAttempt) {
      setBadTermsClickAttempt(false);
    }
  }, [isTermsApproved, setTermsApproved, isBadTermsClickAttempt]);

  const handleClickTerms = React.useCallback(() => {
    if (isTermsApproved) {
      onApproveClick();
    } else {
      setIsTermsShake(true);
      setBadTermsClickAttempt(true);
    }
  }, [isTermsApproved, onApproveClick]);

  return (
    <Scaffold
      title={<ScaffoldTitle label={translate(STRINGS.MEDFLYT_PASSPORT)} />}
      className="MedFlytPassportTermsApprovement"
      onClickGoBack={onCancelClick}
    >
      <div className="__container">
        <AppSlideFadeIn>
          <div className="__image" />
        </AppSlideFadeIn>
        <AppSlideFadeIn delay={200}>
          <div
            className={classNames("__terms_wrapper", { shake: isTermsShake })}
            onAnimationEnd={() => setIsTermsShake(false)}
          >
            <MedFlytPassportLogo />
            <div className="__terms_text">
              <p>{translate(STRINGS.PASSPORT_TERMS_TEXT)}</p>
            </div>
            <div className="__terms_consent">
              <div className="checkbox">
                <input
                  type="checkbox"
                  className={"checkbox__input"}
                  onChange={handleClickSetTermsApproved}
                />
                <span className="checkbox__checkmark" />
              </div>
              <div
                className="__terms_consent_text"
                data-text-color={isBadTermsClickAttempt ? "danger" : "#283847"}
              >
                <span>{translate(STRINGS.I_HAVE_READ_AND_AGREE)} </span>
                <span
                  className="__terms_of_privacy_policy"
                  onClick={() => {
                    openExternalUrl("https://www.medflyt.com/privacy-policy");
                  }}
                >
                  {translate(STRINGS.TERMS_OF_MEDFLYT_PRIVACY_POLICY)}
                </span>
              </div>
            </div>
            <div className="__terms_start_use_box">
              <AppButton
                variant="filled"
                color="primary"
                className={!isTermsApproved ? "disabled" : ""}
                onClick={handleClickTerms}
              >
                {translate(STRINGS.START_USING_MEDFLYT_PASSPORT)}
              </AppButton>
            </div>
          </div>
        </AppSlideFadeIn>
      </div>
    </Scaffold>
  );
};

export default React.memo(MedFlytPassportTermsApprovement);
